import {i18n} from '@/plugins/i18next';

let AdvertHeader = {
  getHeader() {
    return [
      {
        text: 'Id',
        value: 'id',
        default: true,
        filter: {
          type: 'text',
          group: 0,
          order: 1
        }
      },
      {
        text: i18n.t('common:image'),
        value: 'image',
        default: true
      },
      {
        text: i18n.t('common:name'),
        value: 'name',
        filter: {
          type: 'text',
          group: 0,
          order: 2
        },
        default: true
      },
      {
        text: i18n.t('common:type'),
        value: 'advertType',
        default: true
      },
      {
        text: i18n.t('common:start-date'),
        value: 'dateStart',
        filter: {
          type: 'date',
          group: 1,
          order: 1
        },
        default: true
      },
      {
        text: i18n.t('common:end-date'),
        value: 'dateEnd',
        filter: {
          type: 'date',
          group: 1,
          order: 2
        },
        default: true
      },
      {
        text: i18n.t('common:budget'),
        value: 'budget',
        default: true
      },
      {
        text: i18n.t('display/advert:overview.played-budget'),
        value: 'playedBudget',
        default: true
      },
      {
        text: i18n.t('display/advert:overview.played'),
        value: 'played',
        default: true
      },
      {
        text: i18n.t('display/advert:overview.campaign-done'),
        value: 'campaignDone',
        default: true,
        sortable: false
      },
      {
        text: i18n.t('common:active'),
        value: 'active',
        default: true,
        filter: {
          type: 'checkbox',
          group: 3,
          order: 1,
          hint: i18n.t('display/advert:overview.tooltip.active')
        }
      },
      {
        text: i18n.t('display/advert:overview.deleted'),
        value: 'deleted',
        filter: {
          type: 'checkbox',
          group: 3,
          order: 2,
          hint: i18n.t('display/advert:overview.tooltip.deleted')
        },
        default: true
      },
      {
        text: i18n.t('common:status'),
        value: 'status',
        default: true,
        sortable: false
      },
      {
        text: i18n.t('common:customer'),
        value: 'customer',
        filter: {
          type: 'multiselect',
          group: 1,
          order: 3,
          url: 'customer/all-customers'
        },
        hide: true
      },
      {
        text: i18n.t('common:tags'),
        value: 'tags',
        filter: {
          type: 'multiselect',
          optionsName: 'tags',
          group: 2,
          order: 1,
          url: 'display/tag'
        },
        hide: true
      },
      {
        text: i18n.t('common:black-tags'),
        value: 'blackTags',
        filter: {
          type: 'multiselect',
          optionsName: 'tags',
          group: 2,
          order: 2,
          url: 'display/tag'
        },
        hide: true
      },
      {
        text: i18n.t('display/advert:edit.labels.budget-type'),
        value: 'budgetType',
        filter: {
          type: 'select',
          enum: 'true',
          optionsName: "budgetTypes",
          group: 2,
          order: 3
        },
        hide: true
      },
      {
        text: i18n.t('display/advert:edit.labels.button-content'),
        value: 'buttonContent',
        filter: {
          type: 'select',
          enum: 'true',
          group: 0,
          order: 4
        },
        hide: true
      },
      {
        text: i18n.t('display/advert:edit.labels.visible-all'),
        value: 'visibleAll',
        filter: {
          type: 'checkbox',
          group: 3,
          order: 2,
          hint: i18n.t('display/advert:overview.tooltip.visible-all')
        },
        hide: true
      },
      {
        text: i18n.t('display/advert:overview.inhouse'),
        value: 'inHouse',
        filter: {
          type: 'checkbox',
          group: 3,
          order: 4,
          hint: i18n.t('display/advert:overview.tooltip.inhouse')
        },
        hide: true
      },
      {
        text: i18n.t('display/advert:overview.currently-played'),
        value: 'isPlayed',
        filter: {
          type: 'checkbox',
          group: 3,
          order: 5,
          hint: i18n.t('display/advert:overview.tooltip.currently-played')
        },
        hide: true
      },
      {
        text: "",
        value: "controls",
        sortable: false,
        hideInColumnMenu: true,
        default: true
      }
    ];
  },

  getUserHeader() {
    return [
      {
        text: i18n.t('common:image'),
        value: 'image',
        default: true
      },
      {
        text: i18n.t('common:name'),
        value: 'name',
        filter: {
          type: 'text',
          group: 0,
          order: 1
        },
        default: true
      },
      {
        text: i18n.t('common:start-date'),
        value: 'dateStart',
        default: true
      },
      {
        text: i18n.t('display/advert:edit.labels.button-content'),
        value: 'buttonContent',
        filter: {
          type: 'select',
          enum: 'true',
          group: 1,
          order: 1
        }
      },
      {
        text: i18n.t('display/advert:overview.on-device'),
        value: 'inPlaylist'
      },
      {
        text: i18n.t('display/advert:overview.currently-played'),
        value: 'isPlayed',
        filter: {
          type: 'checkbox',
          group: 2,
          order: 1,
          hint: i18n.t('display/advert:overview.tooltip.currently-played')
        },
        hide: true
      },
      {
        text: i18n.t('common:active'),
        value: 'active',
        default: true,
        filter: {
          type: 'checkbox',
          group: 3,
          order: 1,
          hint: i18n.t('display/advert:overview.tooltip.active')
        },
        hide: true
      },
      {
        text: "",
        value: "controls",
        sortable: false,
        hideInColumnMenu: true,
        default: true
      }
    ];
  }
}
export default AdvertHeader;
